import { render, staticRenderFns } from "./FeildSimple.vue?vue&type=template&id=4bc2396a&"
import script from "./FeildSimple.vue?vue&type=script&lang=js&"
export * from "./FeildSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports